import React from 'react';
import { Box, Typography } from '@mui/material';

/**
 * Flag icon component with count - single source of truth for flag icon design
 * @param {number} count - The flag count to display
 * @returns {JSX.Element|null} Flag icon component or null if count is 0
 */
export const FlagIcon = ({ count }) => {
  if (!count || count === 0) return null;
  const displayCount = count > 999 ? '999+' : count;
  
  return (
    <Box
      component="span"
      sx={{
        ml: 0.5,
        position: 'relative',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: count > 999 ? 32 : count > 99 ? 28 : 20,
        height: 16,
        backgroundColor: 'error.main',
        clipPath: 'polygon(0 0, calc(100% - 5px) 0, 100% 50%, calc(100% - 5px) 100%, 0 100%)',
        borderRadius: '2px 0 0 2px',
      }}
    >
      <Typography
        variant="caption"
        sx={{
          fontSize: '0.7rem',
          fontWeight: 'bold',
          color: 'white',
          lineHeight: 1,
          textShadow: '0 1px 1px rgba(0,0,0,0.3)',
        }}
      >
        {displayCount}
      </Typography>
    </Box>
  );
};

/**
 * Generate flag icon HTML string for use in dangerouslySetInnerHTML
 * @param {number} count - The flag count to display
 * @returns {string} HTML string for flag icon
 */
export const getFlagIconHTML = (count) => {
  if (!count || count === 0) return '';
  const displayCount = count > 999 ? '999+' : count;
  const width = count > 999 ? '32px' : count > 99 ? '28px' : '20px';
  return `<span style="
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: ${width};
    height: 16px;
    background-color: #f44336;
    clip-path: polygon(0 0, calc(100% - 5px) 0, 100% 50%, calc(100% - 5px) 100%, 0 100%);
    border-radius: 2px 0 0 2px;
    margin-left: 4px;
    vertical-align: middle;
  ">
    <span style="
      font-size: 0.7rem;
      font-weight: bold;
      color: white;
      line-height: 1;
      text-shadow: 0 1px 1px rgba(0,0,0,0.3);
    ">${displayCount}</span>
  </span>`;
};

